module.exports = import("https://static.ernstings-family.com/webshop/resizable-iframe/20240702T0835310000/index.es.js");;